<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        depressed
        class="mb-2"
        v-on="on"
      >
        {{ $t('Admin.SickLeave.Notify.History') }}
      </v-btn>
    </template>

    <v-card>
      <!---->
      <v-card-title>
        {{ $t('Admin.SickLeave.Notify.NotifiedStaff') }}
      </v-card-title>

      <v-skeleton-loader
        v-if="waiting"
        type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
      />

      <!-- start of new code 20220625 -->
      <div
        v-if="!waiting"
        class="pa-4"
      >
        <template v-if="showingFlowId === null && mcReceiverInfoList">
          <!--
          <v-card-title class="mx-n4">
            {{ $t('eDocInternal.theLastProcessPerson') }}
          </v-card-title>
          -->
          <v-card
            v-for="(leaf, index) in mcReceiverInfoList"
            :key="index"
            class="d-inline-block mr-2 mb-2 pa-4 teal lighten-5"
            rounded
            elevation="4"
            @click="getAncestorProcess(leaf.processMcReceiverInfo, index)"
          >
            <div class="text-body-2">
              {{ getLastReceiver(leaf.processMcReceiverInfo).notifiedEntityAbbr }}
            </div>
            <div>
              <template v-if="getLastReceiverStatus(leaf.processMcReceiverInfo) === 'A' || getLastReceiverStatus(leaf.processMcReceiverInfo) === 'B'">
                {{ showSenderOrGroupName(getLastReceiver(leaf.processMcReceiverInfo)) }}
              </template>
              <template v-else>
                {{ showReceiverOrGroupName(getLastReceiver(leaf.processMcReceiverInfo)) }}
              </template>
              <!-- {{ $chPtObjData('chinReceiverName',leaf) }} -->
            </div>
            <div class="text-body-2 grey--text">
              <template v-if="getLastReceiverStatus(leaf.processMcReceiverInfo) === 'A' || getLastReceiverStatus(leaf.processMcReceiverInfo) === 'B'">
                {{ momentWithHyphen(getLastReceiver(leaf.processMcReceiverInfo).createdTime).format('YYYY-MM-DD HH:mm') }}

                <!--
                <br>({{ $t('eDocInternal.completeTime') }})
                -->
              </template>
              <template v-if="getLastReceiverStatus(leaf.processMcReceiverInfo) === 'L'">
                {{ momentWithHyphen(getLastReceiver(leaf.processMcReceiverInfo).modifiedTime).format('YYYY-MM-DD HH:mm') }}
              </template>
              <template v-else-if="getLastReceiver(leaf.processMcReceiverInfo).createdTime">
                <!--
                  {{ momentWithHyphen(getLastReceiver(leaf.processMcReceiverInfo).createdTime).format('YYYY-MM-DD HH:mm') }}
                <br>({{ $t('eDocInternal.confirmReceivedTime') }})
                -->
              </template>
              <template v-else>
                {{ $t('eDocInternal.unRead') }}
              </template>
            </div>
            <div class="text-body-2 grey--text">
              <template v-if="getLastReceiverStatus(leaf.processMcReceiverInfo) === 'L'">
                (
                {{ showReceiverOrGroupName(getLastReceiver(leaf.processMcReceiverInfo)) }}
                {{ $t('Text.Cancel') }}
                )
              </template>

              <template v-else-if="getLastReceiverStatus(leaf.processMcReceiverInfo) === 'A'">
                <!--(
                {{ $chPtObjData('chinSenderName', leaf.processMcReceiverInfo[0]) }}
                批閱
                )-->
                {{ $t('DocFlow.StatusCode.APPROVER_CLOSED') }}
              </template>

              <template v-else-if="getLastReceiverStatus(leaf.processMcReceiverInfo) === 'B'">
                <!--(
                {{ $chPtObjData('chinSenderName', leaf.processMcReceiverInfo[0]) }}
                知悉
                )-->
                {{ $t('DocFlow.StatusCode.NORMAL_CLOSED') }}
              </template>
            </div>
          </v-card>
        </template>
        <template v-else>
          <v-btn icon>
            <v-icon @click="showingFlowId = null">
              {{ mdiArrowLeft }}
            </v-icon>
          </v-btn>
          <v-skeleton-loader
            v-if="nodeLoading"
            type="list-item-avatar, divider, list-item-avatar"
          />
          <div
            v-if="!nodeLoading"
            class="ml-0 ml-md-10"
          >
            <table>
              <thead>
                <tr>
                  <th />
                  <th class="text-center" />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in ancestorProcess"
                  :key="`anc${item.id}`"
                >
                  <td class="text-center">
                    <v-card
                      class="pa-2 text-left"
                      flat
                    >
                      <div class="text-body-2">
                        {{ item.notifiedEntityAbbr }}
                      </div>
                      <div>
                        <!-- {{ showSenderOrGroupName(item) }} -->
                        <!-- {{ showReceiverOrGroupName(item) }} -->
                        <template v-if="(item.statusCode === 'A' || item.statusCode === 'B')">
                          {{ showSenderOrGroupName(item) }}
                        </template>
                        <template v-else>
                          <!--
                          {{ showReceiverOrGroupName(item) }}
                          -->
                          {{ showSenderOrGroupName(item) }}
                        </template>
                      </div>
                      <div class="text-body-2 grey--text">
                        {{ momentWithHyphen(item.createdTime).format('YYYY-MM-DD HH:mm') }}
                      </div>
                    </v-card>
                    <v-icon
                      v-if="((index + 1) < ancestorProcessLength) || (lastProcess && lastProcess.statusCode !== 'A' && lastProcess.statusCode !== 'B')"
                      icon
                    >
                      {{ mdiArrowDownBoldOutline }}
                    </v-icon>
                  </td>
                  <td class="pl-4">
                    <div
                      v-if="item.statusCode === 'C'"
                      class="mb-6"
                    />
                    <div
                      v-if="item.senderInstruction"
                      class="mb-6"
                    >
                      <span class="font-weight-bold">“</span>
                      {{ item.senderInstruction }}
                      <span class="font-weight-bold">”</span>
                    </div>
                  </td>
                </tr>
                <!-- last process -->
                <tr v-if="lastProcess && lastProcess.statusCode !== 'A' && lastProcess.statusCode !== 'B'">
                  <td class="text-center">
                    <v-card
                      class="pa-2 text-left"
                      flat
                    >
                      <div
                        class="text-body-2"
                      >
                        {{ lastProcess.notifiedEntityAbbr }}
                      </div>
                      <div v-if="lastProcess">
                        <!--
                        <template
                          v-if="lastProcess.statusCode === 'A' || lastProcess.statusCode === 'B'"
                          class="mb-6"
                        >
                          {{ showSenderOrGroupName(lastProcess) }}
                        </template>
                        <template v-else>
                          {{ showReceiverOrGroupName(lastProcess) }}
                        </template>
                        -->
                        {{ showReceiverOrGroupName(lastProcess) }}
                        <template v-if="lastProcess.statusCode === 'L'">
                          (
                          <template v-if="lastProcess.remark">
                            {{ $t('TaskList.CancelReason') }} : {{ lastProcess.remark }}
                          </template>
                          <template v-else>
                            {{ $t('Text.Cancel') }}
                          </template>
                          )
                        </template>
                      </div>
                    </v-card>
                  </td>
                  <td class="pl-4" />
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
      <!-- end of new code-->

      <v-card-text v-if="!waiting">
        <v-btn
          v-if="!showSearchStaff"
          v-show="false"
          text
          color="primary"
          @click="showSearchStaff = true"
        >
          {{ $t('Admin.SickLeave.Notify.NotifyOthers') }}
        </v-btn>

        <v-expand-transition>
          <div v-show="showSearchStaff">
            <br><br>
            <h4>{{ $t('eleave.Notification') }}</h4>
            <v-row>
              <v-col cols="8">
                <s-search-staff
                  show-group
                  :select.sync="searchStaffCode"
                  :staff.sync="searchStaff"
                  :label="$t('PublicServant.Staff')"
                />
              </v-col>
              <v-col>
                <v-btn
                  class="mt-2 ml-2"
                  @click="addStaffToNotice"
                >
                  {{ $t('PublicServant.Action.New') }}
                </v-btn>
              </v-col>
            </v-row>
            <div style="margin-left: -16px;">
              <v-list-item
                v-for="(staff, index) in paramNotifyInfos"
                :key="staff.staffCode"
              >
                <v-list-item-icon
                  @click="removeStaff(index)"
                >
                  <v-icon color="pink">
                    {{ mdiClose }}
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ genNoticeDesc(staff) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </v-expand-transition>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-show="false"
          color="primary"
          :disabled="paramNotifyInfos.length === 0"
          :loading="loading"
          @click="dafNotify"
        >
          {{ $t('Text.Submit') }}
        </v-btn>
        <v-btn
          depressed
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { momentWithHyphen } from '@/utils/datetimeUtil'
import SSearchStaff from '@/components/SSearchStaff'
import sickLeaveApi from '@/api/leave/sickLeave'
import docFlowApi from '@/api/eDocInternal/docFlow'
import { globalModule } from '@/store/moduleName'
import { sickLeaveMethod } from '@/mixins/sickLeaveMethod'
import { SEARCH_STAFF_RECORD_TYPE } from '@/constant/constant'
import { mdiClose, mdiArrowLeft, mdiArrowDownBoldOutline } from '@mdi/js'
import { nvl } from '@/utils/stringUtil'

export default {
  components: {
    SSearchStaff
  },
  mixins: [sickLeaveMethod],
  props: {
    cert: {
      type: Object,
      required: true
    },
    isInTaskList: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mdiArrowDownBoldOutline: mdiArrowDownBoldOutline,
      mdiArrowLeft: mdiArrowLeft,
      loading: false,
      waiting: false,
      notifyList: [],
      mcReceiverInfoList: [],
      dialog: false,
      showSearchStaff: false,
      searchStaffCode: null,
      searchStaff: null,
      paramNotifyInfos: [],
      mdiClose,
      processLeaf: [],
      showingFlowId: null,
      ancestorProcess: [],
      ancestorProcessLength: 0,
      lastProcess: null,
      pageLoading: false,
      nodeLoading: false
    }
  },
  watch: {
    dialog: function (val) {
      //      console.info('dialog: ' + val)
      if (val) {
        // console.log('val true')
        this.showSearchStaff = false
        this.paramNotifyInfos = []
        this.getNotifyList(this.cert)
        this.getProcessLeaf(this.processId)
        this.showingFlowId = null
      } else {
        // console.log('val false')
      }
    }
  },
  created () {
    console.log('cert 123 : ' + JSON.stringify(this.cert))
    console.log('cert.paramNotifyInfos : ' + JSON.stringify(this.paramNotifyInfos))
    this.mcReceiverInfoList = this.cert.paramNotifyInfos
  },
  methods: {
    genNoticeDesc: function (notice) {
      if (notice.notifiedGid) {
        return nvl(notice.chinNotifiedGroupName, '') + (notice.chinNotifiedGroupName ? ' ' : '') + nvl(notice.portNotifiedGroupName, '')
      } else {
        return notice.notifiedEuid + ' ' + nvl(notice.chinNotifiedStaffName, '') + (notice.chinNotifiedStaffName ? ' ' : '') + nvl(notice.portNotifiedStaffName, '')
      }
    },
    addStaffToNotice: function () {
      if (this.searchStaffCode !== null) {
        let tStaff = {}
        if (this.searchStaff.recordType === SEARCH_STAFF_RECORD_TYPE.GROUP) {
          tStaff.notifiedGid = this.searchStaff.definedGroupId
          tStaff.chinNotifiedGroupName = this.searchStaff.definedGroupChinName
          tStaff.portNotifiedGroupName = this.searchStaff.definedGroupPortName
        } else {
          tStaff.notifiedEuid = this.searchStaff.euid
          tStaff.notifiedStaffCode = this.searchStaff.staffCode
          tStaff.chinNotifiedStaffName = this.searchStaff.chinName
          tStaff.portNotifiedStaffName = this.searchStaff.portName
        }
        this.paramNotifyInfos.push(tStaff)
        this.searchStaffCode = null
      }
    },
    removeStaff: function (index) {
      this.paramNotifyInfos.splice(index, 1)
    },
    getNotifyList: function (cert) {
      //      console.info('getNotifyList, ' + cert.keyNo + ',- ' + JSON.stringify(this.cert) + ', ' + this.cert.paramNotifyInfos.length)
      if (cert.dfInflowId || cert.dfInflowIdSupport) {
        this.waiting = true
        this.notifyList = []
        // sickLeaveApi.findMCNotifyInfo(cert.dfInflowId, cert.dfInflowIdSupport, cert.keyNo, cert.id, rsp => {
        //   this.waiting = false
        //   if (rsp.status === 201 || rsp.status === 200) {
        //     this.notifyList = rsp.data
        //     console.debug(this.notifyList)
        //   }
        // })

        if (!this.isInTaskList) {
          sickLeaveApi.findMcReceiverInfo(cert.keyNo, cert.id, rsp => {
          //          console.info('findMcReceiverInfo 1')
            this.waiting = false
            if (rsp.status === 201 || rsp.status === 200) {
              this.mcReceiverInfoList = rsp.data
              console.debug(JSON.stringify(rsp.data))
            }
          })
        } else {
          docFlowApi.getMcProcessReceiverInfo(cert.dfProcessId, rsp => {
            this.waiting = false
            if (rsp.status === 201 || rsp.status === 200) {
              this.mcReceiverInfoList = rsp.data
            }
          })
        }
      } else {
        this.mcReceiverInfoList = this.cert.paramNotifyInfos
      }
    },
    dafNotify: function () {
      this.loading = true
      sickLeaveApi.dafNotify(this.cert.keyNo, this.cert.id, this.paramNotifyInfos, resp => {
        this.loading = false
        if (resp.status === 201 || resp.status === 200) {
          this.$emit('update', resp.data)
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.dialog = false
        }
      })
    },

    async getProcessLeaf (processId) {
      this.pageLoading = true
      // await docFlowApi.getProcessLeaf(processId, resp => {
      //   this.processLeaf = resp.data
      // })
      this.pageLoading = false
    },

    async getAncestorProcess (mcReceiverInfo, index) {
      console.debug('getAncestorProcess, ' + JSON.stringify(mcReceiverInfo) + ', ' + mcReceiverInfo.length + ', ' + index)
      this.nodeLoading = true
      this.showingFlowId = 1
      // this.lastProcess = this.processLeaf[index]
      // console.debug('this.lastProcess : ' + JSON.stringify(this.lastProcess))
      // await docFlowApi.getAncestorProcess(processId, this.inflowStatus, resp => {
      //   this.ancestorProcess = resp.data

      this.ancestorProcess = mcReceiverInfo
      // this.ancestorProcess = mcReceiverInfo.filter(info => info.statusCode === 'C')
      this.ancestorProcessLength = this.ancestorProcess.length
      //      console.debug(this.ancestorProcessLength)
      // })
      this.lastProcess = this.ancestorProcess[this.ancestorProcess.length - 1]
      this.nodeLoading = false
    },

    showReceiverOrGroupName (staff) {
      // console.debug('showReceiverOrGroupName : ' + JSON.stringify(staff))
      if (!staff) {
        return ''
      }
      if (staff.chinNotifiedStaffName || staff.portNotifiedStaffName) {
        return this.$chPtObjData('chinNotifiedStaffName', staff)
      } else if (staff.chinNotifiedGroupName || staff.portNotifiedGroupName) {
        return this.$chPtObjData('chinNotifiedGroupName', staff)
      } else if (staff.chinReceiverName || staff.portReceiverName) {
        return this.$chPtObjData('chinReceiverName', staff)
      } else if (staff.chinReceiverGroupName || staff.portReceiverGroupName) {
        return this.$chPtObjData('chinReceiverGroupName', staff)
      }
    },

    showSenderOrGroupName (staff) {
      if (staff.chinSenderName || staff.portSenderName) {
        return this.$chPtObjData('chinSenderName', staff)
      } else {
        // return this.$chPtObjData('chinSendFromGroupName', staff) // backend didn't implement this field
      }
    },

    getLastReceiver (list) {
      if (list.length === 0) {
        return ''
      }
      // console.debug('getLastStatus, ' + list.length)
      var last = list[list.length - 1]

      return last
    },

    getLastReceiverStatus (list) {
      if (list.length === 0) {
        return ''
      }
      // console.debug('getLastStatus, ' + list.length)
      var last = list[list.length - 1]

      return last.statusCode
    },

    momentWithHyphen

  }
}
</script>
